var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_claimType_form_dialog_cliamItemTitle"),
      dialog: _vm.show,
      width: "800",
      maxWidth: "800",
      scrollable: "",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                avPerPage: 50,
                height: 500,
                showFooter: false,
                defaultSelect: _vm.PorpertyData,
                items: _vm.desserts,
                itemKey: "uuid",
                showSelect: _vm.showSelect,
              },
              on: {
                select: function (sel) {
                  return (_vm.selected = sel)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getCommonLangValue(item.claim_item_type_name)
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.onSave, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }